import { find } from 'lodash';

import FilterWiFi from 'src/components/Filters/FilterWiFi';
import FilterBeachSurface from 'src/components/Filters/FilterBeachSurface';
import FilterBeachType from 'src/components/Filters/FilterBeachType';
import FilterFacilities from 'src/components/Filters/FilterFacilities';
import FilterFamilyWithKids from 'src/components/Filters/FilterFamilyWithKids';
import FilterSpa from 'src/components/Filters/FilterSpa';
import FilterTypePlacement from 'src/components/Filters/FilterTypePlacement';
import FilterSkiDistance from 'src/components/Filters/FilterSkiDistance';
import FilterStars from 'src/components/Filters/FilterStars';
import FilterOperators from 'src/components/Filters/FilterOperators';
import FilterPrices from 'src/components/Filters/FilterPrices';
import FilterCountries from 'src/components/Filters/FilterCountries';
import FilterRating from 'src/components/Filters/FilterRating';
import FilterRestrictions from 'src/components/Filters/FilterRestrictions';
import FilterLine from 'src/components/Filters/FilterLine';
import FilterCategory from 'src/components/Filters/FilterCategory';
import FilterRegions from 'src/components/Filters/FilterRegions';
import FilterMeals from 'src/components/Filters/FilterMeals';
import FilterPaymentBenefits from 'src/components/Filters/FilterPaymentBenefits';
import FilterHotelName from 'src/components/Filters/FilterHotelName';

const FILTERS = {
  FilterPaymentBenefits,
  FilterCountries,
  FilterStars,
  FilterMeals,
  FilterRating,
  FilterLine,
  FilterRegions,
  FilterTypePlacement,
  FilterPrices,
  FilterHotelName,
  FilterBeachType,
  FilterBeachSurface,
  FilterOperators,
  FilterRestrictions,
  FilterCategory,
  FilterWiFi,
  FilterSpa,
  FilterFacilities,
  FilterFamilyWithKids,
  FilterSkiDistance,
  // FilterLtExtras,
};

export const FILTERS_LIST = [
  FILTERS.FilterPaymentBenefits,
  FILTERS.FilterCountries,
  FILTERS.FilterStars,
  FILTERS.FilterMeals,
  FILTERS.FilterRating,
  FILTERS.FilterLine,
  FILTERS.FilterRegions,
  FILTERS.FilterTypePlacement,
  FILTERS.FilterPrices,
  FILTERS.FilterHotelName,
  FILTERS.FilterBeachType,
  FILTERS.FilterBeachSurface,
  FILTERS.FilterOperators,
  FILTERS.FilterRestrictions,
  FILTERS.FilterCategory,
  FILTERS.FilterWiFi,
  FILTERS.FilterSpa,
  FILTERS.FilterFacilities,
  FILTERS.FilterFamilyWithKids,
  FILTERS.FilterSkiDistance,
];

export const getFilterByName = (name) =>
  find(FILTERS, ({ filterName }) => filterName === name);
